;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/connect/form-confirmation/:form\",\"regex\":\"^/connect/form-confirmation/([^/]+)$\",\"paramNames\":[\"form\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/blog/:id/edit\",\"regex\":\"^/admin/blog/([^/]+)/edit$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about-us\"},{\"path\":\"/about-us/faq\"},{\"path\":\"/about-us/flamingo\"},{\"path\":\"/about-us/mission\"},{\"path\":\"/about-us/team\"},{\"path\":\"/blog\"},{\"path\":\"/connect/contact\"},{\"path\":\"/connect/feedback\"},{\"path\":\"/get-started/business-owners\"},{\"path\":\"/get-started/core-policies\"},{\"path\":\"/get-started/entrepreneurs\"},{\"path\":\"/get-started/experts\"},{\"path\":\"/get-started/investors\"},{\"path\":\"/get-started/supporters\"},{\"path\":\"/get-started/what-are-worker-coops\"},{\"path\":\"/legal/privacy\"},{\"path\":\"/legal/terms\"},{\"path\":\"/security\"},{\"path\":\"/services/flocklist\"},{\"path\":\"/services/flocktank\"},{\"path\":\"/services/flockworker\"},{\"path\":\"/team/samuel-forcum\"},{\"path\":\"/account\"},{\"path\":\"/account/activity\"},{\"path\":\"/account/connections\"},{\"path\":\"/account/password\"},{\"path\":\"/account/profile\"},{\"path\":\"/admin\"},{\"path\":\"/admin/blog\"},{\"path\":\"/admin/blog/categories\"},{\"path\":\"/admin/blog/new\"},{\"path\":\"/auth\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/mfa\"},{\"path\":\"/auth/resend-verification\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/auth/sign-in\"},{\"path\":\"/auth/sign-up\"},{\"path\":\"/auth/step-up\"},{\"path\":\"/auth/verify-email\"},{\"path\":\"/auth/verify-email-change\"},{\"path\":\"/oauth/consent\"},{\"path\":\"/settings\"},{\"path\":\"/settings/activity\"},{\"path\":\"/settings/applications\"},{\"path\":\"/settings/connections\"},{\"path\":\"/settings/emails\"},{\"path\":\"/settings/password\"},{\"path\":\"/settings/preferences\"},{\"path\":\"/settings/privacy\"},{\"path\":\"/settings/profile\"},{\"path\":\"/settings/security\"},{\"path\":\"/settings/sessions\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import { scrubPIIFromEvent, scrubPIIFromString } from "@/app/lib/utils/sentry-privacy";

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

const IGNORED_ERRORS = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
  "Non-Error promise rejection captured",
  "Load failed",
  "Failed to fetch",
];

if (!dsn) {
  if (process.env.NODE_ENV === "production") {
    console.warn("[Sentry] DSN not set. Error tracking disabled.");
  }
} else {
  Sentry.init({
    dsn,

    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

    maxBreadcrumbs: process.env.NODE_ENV === "production" ? 50 : 100,

    integrations: (defaultIntegrations) => {
      const piiScrubDisabled = process.env.NEXT_PUBLIC_SENTRY_DISABLE_PII_SCRUB === "true";
      const integrations = [
        ...defaultIntegrations,
        Sentry.browserTracingIntegration(),
        Sentry.breadcrumbsIntegration({
          console: process.env.NODE_ENV === "production" ? false : true,
          dom: {
            serializeAttribute: ["data-action", "aria-label", "data-testid"],
          },
          fetch: true,
          history: true,
          sentry: false,
        }),
      ];

      if (process.env.NODE_ENV === "production") {
        integrations.push(
          Sentry.replayIntegration({
            maskAllText: piiScrubDisabled ? false : true,
            maskAllInputs: piiScrubDisabled ? false : true,
            blockAllMedia: piiScrubDisabled ? false : true,
          })
        );
      }

      return integrations;
    },

    replaysSessionSampleRate: process.env.NODE_ENV === "production" ? 0.01 : 0,
    replaysOnErrorSampleRate: 1.0,

    environment: process.env.NODE_ENV,
    release: process.env.NEXT_PUBLIC_RELEASE || "development",

    ignoreErrors: IGNORED_ERRORS,

    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.data?.url?.includes("analytics") ||
          breadcrumb.data?.url?.includes("_next/static") ||
          breadcrumb.data?.url?.includes("fonts.")) {
        return null;
      }
      return breadcrumb;
    },

    beforeSend(event) {
      if (event.extra) {
        event.extra = scrubPIIFromEvent(
          event.extra as Record<string, unknown>
        );
      }
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => {
          if (breadcrumb.data) {
            breadcrumb.data = scrubPIIFromEvent(
              breadcrumb.data as Record<string, unknown>
            );
          }
          if (breadcrumb.message) {
            breadcrumb.message = scrubPIIFromString(breadcrumb.message);
          }
          return breadcrumb;
        });
      }
      return event;
    },
  });
}
